module.exports = __webpack_public_path__ + "static/media/shred_bus.f76bf3e5.jpg";